module.exports = __webpack_public_path__ + "img/cancelado.a374b322.jpg";